"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const section = document.querySelector(".o-home-specialties");
        if (!section) return;

        const sliderEl = section.querySelector(
            ".o-home-specialties__grid.swiper",
        );
        if (!sliderEl) return;

        // pega o bloco de setas "ativo" (o que estiver visível no breakpoint)
        const getActiveArrows = () => {
            // se você controla via CSS (display:none), isso resolve bem:
            const desktop = section.querySelector(
                ".o-home-specialties__arrows-desktop",
            );
            const mobile = section.querySelector(
                ".o-home-specialties__arrows-mobile",
            );

            const isVisible = (el) => el && el.offsetParent !== null;

            if (isVisible(desktop)) return desktop;
            if (isVisible(mobile)) return mobile;

            // fallback: tenta desktop primeiro
            return desktop || mobile;
        };

        const getNavEls = () => {
            const arrowsWrap = getActiveArrows();
            if (!arrowsWrap) return {};
            return {
                prevEl: arrowsWrap.querySelector(
                    ".o-home-specialties__arrow--prev",
                ),
                nextEl: arrowsWrap.querySelector(
                    ".o-home-specialties__arrow--next",
                ),
            };
        };

        const swiper = new Swiper(sliderEl, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 26,
            autoHeight: true,
            loop: true,
            navigation: getNavEls(),
            breakpoints: {
                680: { slidesPerView: 2 },
                1280: { slidesPerView: 3 },
                1336: { slidesPerView: 4 },
                1600: { slidesPerView: 5 },
            },
        });

        // quando muda breakpoint (resize), troque as setas pro bloco correto
        const updateNavigation = () => {
            const { prevEl, nextEl } = getNavEls();
            if (!prevEl || !nextEl) return;

            swiper.params.navigation.prevEl = prevEl;
            swiper.params.navigation.nextEl = nextEl;

            // re-inicializa navigation com os novos elementos
            swiper.navigation.destroy();
            swiper.navigation.init();
            swiper.navigation.update();
        };

        window.addEventListener("resize", updateNavigation);
        updateNavigation();
    });
}
